module.exports = __webpack_public_path__ + "img/限时特惠.b9cadbf1.png";